<app-case-breadcrumb 
    *ngIf="loaded" 
    [caseId]="caseService.case._id" 
    [caseEventId]="caseEvent.id"
    [eventFormId]="eventForm.id"
></app-case-breadcrumb>
<paper-button *ngIf="loaded" class="new-issue-button" routerLink="/new-issue/{{caseId}}/{{caseEvent.id}}/{{eventForm.id}}"><mwc-icon>playlist_add</mwc-icon> new issue</paper-button>
<app-tangy-forms-player #formPlayer></app-tangy-forms-player>

